import React, { useState } from "react";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import { TIMEZONES } from "../lib/helpers";

// Éditeur de RDV (visio OU physique) pour une phase. onSave(body) doit renvoyer une promesse.
export const RdvEditor = ({ rdv = {}, onSave, testId = "phase" }) => {
  const hasRdv = !!rdv.rdv_type;
  const [open, setOpen] = useState(hasRdv);
  const [type, setType] = useState(rdv.rdv_type || "visio");
  const [date, setDate] = useState(rdv.rdv_date || "");
  const [time, setTime] = useState(rdv.rdv_time || "");
  const [tz, setTz] = useState(rdv.rdv_timezone || "Asia/Dubai");
  const [link, setLink] = useState(rdv.rdv_link || "");
  const [address, setAddress] = useState(rdv.rdv_address || "");
  const [saving, setSaving] = useState(false);
  const inCls = "text-xs border border-marine/20 rounded-sm p-1.5 bg-white focus:outline-none focus:border-marine/50";

  const save = async () => {
    if (!date || !time) return toast.error("Renseignez la date et l'heure du RDV");
    if (type === "visio" && !link.trim()) return toast.error("Renseignez le lien de la visio");
    if (type === "physique" && !address.trim()) return toast.error("Renseignez l'adresse du RDV");
    setSaving(true);
    try {
      await onSave({ update_rdv: true, rdv_type: type, rdv_date: date, rdv_time: time,
                     rdv_timezone: tz, rdv_link: type === "visio" ? link : "", rdv_address: type === "physique" ? address : "" });
      toast.success("RDV enregistré");
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur lors de l'enregistrement"); }
    finally { setSaving(false); }
  };
  const clear = async () => {
    setSaving(true);
    try {
      await onSave({ update_rdv: true, rdv_type: "", rdv_date: "", rdv_time: "", rdv_timezone: "", rdv_link: "", rdv_address: "" });
      setLink(""); setAddress(""); setDate(""); setTime(""); setOpen(false);
      toast.success("RDV retiré");
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
    finally { setSaving(false); }
  };

  if (!open) {
    return (
      <button onClick={() => setOpen(true)} data-testid={`rdv-add-${testId}`}
        className="mt-3 text-xs text-marine border border-marine/20 rounded-sm px-2.5 py-1.5 hover:bg-marine hover:text-white transition-colors">
        + Ajouter un RDV
      </button>
    );
  }
  const TypeBtn = ({ v, label, icon: Ic }) => (
    <button type="button" onClick={() => setType(v)} data-testid={`rdv-type-${v}-${testId}`}
      className={`flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-sm border transition-colors ${type === v ? "bg-marine text-white border-marine" : "border-marine/25 text-marine hover:bg-marine/5"}`}>
      <Ic size={16} /> {label}
    </button>
  );
  return (
    <div className="mt-3 border-t border-marine/10 pt-3" data-testid={`rdv-editor-${testId}`}>
      <div className="text-xs uppercase tracking-wider text-marine/80 mb-2">Rendez-vous</div>
      <div className="flex gap-2 mb-2">
        <TypeBtn v="visio" label="Visio" icon={Icons.Video} />
        <TypeBtn v="physique" label="Physique" icon={Icons.MapPin} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {type === "visio" ? (
          <input type="url" value={link} onChange={(e) => setLink(e.target.value)} placeholder="Lien Google Meet (https://meet.google.com/…)"
            data-testid={`rdv-link-${testId}`} className={`${inCls} sm:col-span-2`} />
        ) : (
          <input type="text" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="Adresse du rendez-vous (ex. Clinique, rue…, Dubaï)"
            data-testid={`rdv-address-${testId}`} className={`${inCls} sm:col-span-2`} />
        )}
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid={`rdv-date-${testId}`} className={inCls} />
        <div className="flex gap-2">
          <input type="time" value={time} onChange={(e) => setTime(e.target.value)} data-testid={`rdv-time-${testId}`} className={`${inCls} flex-1`} />
          <select value={tz} onChange={(e) => setTz(e.target.value)} data-testid={`rdv-tz-${testId}`} className={`${inCls} flex-1`}>
            {TIMEZONES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
        </div>
      </div>
      <div className="flex items-center gap-2 mt-2">
        <button onClick={save} disabled={saving} data-testid={`rdv-save-${testId}`}
          className="text-xs bg-marine text-white rounded-sm px-3 py-1.5 hover:bg-marine-hover transition-colors disabled:opacity-50">Enregistrer</button>
        {hasRdv && <button onClick={clear} disabled={saving} data-testid={`rdv-clear-${testId}`}
          className="text-xs text-bordeaux border border-bordeaux/30 rounded-sm px-3 py-1.5 hover:bg-bordeaux hover:text-white transition-colors disabled:opacity-50">Retirer</button>}
      </div>
    </div>
  );
};

export default RdvEditor;
